import { FiCheck } from "react-icons/fi";
import type {
  MealCompletePickupData,
  MealCompletePickupInternalData,
  MealMonitoringDetailItem,
} from "../../../../../api/meal/types/mealMonitoringDetailType";

interface MealPickupSuccessPopupProps {
  open: boolean;
  item: MealMonitoringDetailItem | null;
  pickupData: MealCompletePickupData | null;
  onConfirm: () => void;
}

const isInternalPickupData = (
  pickupData: MealCompletePickupData | null,
): pickupData is MealCompletePickupInternalData => {
  return pickupData !== null && "menu" in pickupData;
};

const MealPickupSuccessPopup = ({
  open,
  item,
  pickupData,
  onConfirm,
}: MealPickupSuccessPopupProps) => {
  if (!open || !item) {
    return null;
  }

  const initials =
    item.full_name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((value) => value.charAt(0))
      .join("")
      .toUpperCase() || "?";

  const mealName = isInternalPickupData(pickupData)
    ? pickupData.menu.menu_name
    : (item.menu_name ?? "-");

  const category = item.category ?? null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-5">
      <div className="w-full max-w-[360px] overflow-hidden rounded-3xl bg-white shadow-xl">
        <div className="flex flex-col items-center px-6 pb-5 pt-7">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#fff1f0]">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#ff706b] text-white">
              <FiCheck className="text-[25px]" />
            </div>
          </div>

          <p className="mt-4 text-[17px] font-bold text-[#444]">
            Meal Berhasil Diambil
          </p>

          <p className="mt-1 text-center text-[11px] leading-relaxed text-[#999]">
            Pengambilan meal berhasil dicatat.
          </p>

          <div className="mt-5 w-full rounded-2xl bg-[#fafafa] p-4">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#aeb5d8] text-[13px] font-semibold text-white">
                {initials}
              </div>

              <div className="min-w-0 flex-1">
                <p className="truncate text-[13px] font-bold text-[#555]">
                  {item.full_name}
                </p>

                <p className="mt-0.5 text-[10px] text-[#999]">
                  NRP: {item.nrp}
                </p>

                {item.department && (
                  <p className="mt-0.5 truncate text-[10px] text-[#aaa]">
                    {item.department}
                  </p>
                )}
              </div>
            </div>

            <div className="my-4 h-px bg-[#e9e9e9]" />

            <div>
              <p className="text-[10px] font-medium uppercase tracking-wide text-[#aaa]">
                Mendapatkan meal
              </p>

              <div className="mt-1.5 flex w-full min-w-0 flex-nowrap items-center gap-2 overflow-hidden">
                {category && (
                  <span className="inline-flex shrink-0 whitespace-nowrap rounded-lg bg-[#eafaf4] px-3 py-1.5 text-[13px] font-bold tracking-wide text-[#32c896]">
                    {category}
                  </span>
                )}

                <p className="min-w-0 flex-1 truncate whitespace-nowrap text-[14px] font-semibold leading-snug text-[#555]">
                  {mealName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#f0f0f0] p-4">
          <button
            type="button"
            onClick={onConfirm}
            className="flex h-11 w-full items-center justify-center rounded-xl bg-[#ff706b] text-[13px] font-bold text-white transition active:scale-[0.98]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MealPickupSuccessPopup;
